module.exports = __webpack_public_path__ + "static/contact-7be156019db65c385212b6118619896e.png";